import { VdsButton, VdsIcon } from '@volt/volt-extended-components-react';
import { ReactElement } from 'react';

interface CustomIconButtonProps {
  size?: 'medium' | 'large';
  variant?: 'primary' | 'secondary' | 'tertiary' | 'ghost' | 'ghost-alt';
  svgIcon: string;
  onClick: () => void;
  disabled?: boolean;
}

/** The VdsIconButton only supports fairly small size icon buttons, so a custom component is needed in some cases. */
export const CustomIconButton = ({
  size = 'medium',
  variant = 'ghost-alt',
  svgIcon,
  onClick,
  disabled = false,
}: CustomIconButtonProps): ReactElement => {
  const iconSize = size === 'large' ? '2.125rem' : '1.5rem';
  // Use a negative margin on the horizontal axis to pull the sides of the button inwards to make a square.
  const marginOffset = size === 'large' ? '-0.5625rem' : '-0.375rem';

  return (
    <VdsButton variant={variant} size={size} onClick={onClick} disabled={disabled}>
      {/* Note: Do not specify an icon slot or VdsButton will add a margin to the icon. */}
      <VdsIcon svgIcon={svgIcon} size={iconSize} style={{ margin: `0 ${marginOffset}` }} />
    </VdsButton>
  );
};

export default CustomIconButton;
